export class TabVisibilityManager<T extends string> {
  tabVisibility: Record<T, boolean> = {} as Record<T, boolean>;

  constructor(initialState: Record<T, boolean>) {
    this.tabVisibility = {...initialState};
  }

  isTabVisible(name: T): boolean {
    return this.tabVisibility[name];
  }

  resetTabVisibility() {
    Object.keys(this.tabVisibility).forEach((key) => {
      this.tabVisibility[key as T] = false;
    });
  }

  blockVisibilityClick(name: T) {
    if (this.tabVisibility.hasOwnProperty(name)) {
      this.tabVisibility[name] = !this.tabVisibility[name];
    }
  }
}
